import faker from "@faker-js/faker";
import { OrderStatus, Order } from "@src/core/models/order";

export const mockOrder = (overrides?: Order): Order => ({
  assetId: faker.datatype.uuid(),
  createdAt: faker.date.past(),
  createdBy: faker.datatype.uuid(),
  id: faker.datatype.uuid(),
  offerId: faker.datatype.uuid(),
  status: OrderStatus.AwatingConfirmation,
  updatedAt: faker.date.past(),
  updatedBy: faker.datatype.uuid(),
  price: Number(faker.finance.amount(0.02, 0.05)),
  wallet: faker.datatype.uuid(),
  ...(overrides || {}),
});
